const SET_CONTENT_STORE = 'SET_CONTENT_STORE';

export { SET_CONTENT_STORE };
